import React from "react";

import Button from "@mui/material/Button";

import useBillingContext from "@app/analytics/hooks/billing/useBillingContext";
import useLocalStorage from "@app/common/hooks/useLocalStorage";
import LINKS from "@app/common/links";
import ROUTES from "@app/common/routes";
import { planIsUnknown } from "@app/common/utils/billingUtils";

import Alert from "@rui/Alert";
import Link from "@rui/Link";
import { Bold } from "@rui/styles";

const LicenseMaximumAlert = () => {
  const { currentPlan, licenses } = useBillingContext();

  const [dismissed, setDismissed] = useLocalStorage(
    "licenseMaximumAlertDismissed",
    false,
    { migrateKeys: true }
  );

  // licenses.numAvailableForPurchase will only be `0` if the plan has a seat
  // cap, and they've met it, or if we weren't able to fetch their subscription and
  // so don't know the true state of their account
  const showAlert =
    planIsUnknown(currentPlan.type) &&
    licenses.numAvailableForPurchase === 0 &&
    !dismissed;

  if (!showAlert) return null;

  return (
    <Alert
      dismissible
      severity="warning"
      onDismiss={() => setDismissed(true)}
      action={
        <Link to={ROUTES.UPGRADE_ACCOUNT} openInBrowser>
          <Button
            variant="contained"
            color="warning"
            sx={{ height: "40px", whiteSpace: "nowrap" }}
          >
            Upgrade Plan
          </Button>
        </Link>
      }
    >
      <Bold>License maximum reached:</Bold> Your {currentPlan.label} Plan is at
      the maximum of {currentPlan.seatMaximum} licenses. Upgrade to Read Pro or
      Enterprise to purchase more licenses.{" "}
      <Link href={LINKS.MARKETING.PLANS_PRICING}>
        See the benefits of upgrading
      </Link>
      .
    </Alert>
  );
};

export default LicenseMaximumAlert;
